import { useEffect, useState } from "react";
import GetUserRequests from "../../../Controllers/SuperAdmin/GetUserRequests";
import { useNavigate } from "react-router-dom";
import { ToastSuccessMessages } from "../../../Helpers/ToastMessages";
import DeleteUserRequest from "../../../Controllers/SuperAdmin/DeleteUserRequest";

const UserRequestsViewModel = () => {
  const navigate = useNavigate();
  const [AllUserRequests, setAllUserRequests] = useState([]);
  const [IsLoading, setIsLoading] = useState(false);
  const [RequestID, setRequestID] = useState("");
  const [Refresh, setRefresh] = useState(true);

  const HandleRefresh = () => {
    setRefresh(!Refresh);
  };

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const userRequests = await GetUserRequests();
      setAllUserRequests(userRequests);
      setIsLoading(false);
    }
    fetchData();
  }, [Refresh]);

  // Action Confirmation Start
  const [DeleteDialog, setDeleteDialog] = useState(false);

  const handleOpenDeleteDialog = (id) => {
    setRequestID(id);
    setDeleteDialog(true);
  };

  const handleCloseDeleteDialog = async (del) => {
    setDeleteDialog(false);
    if (del === true) {
      await DeleteUserRequest(RequestID);
      ToastSuccessMessages("request/delete-successful");
      HandleRefresh();
      setDeleteDialog(false);
    }
  };
  // Action Confirmation End

  return {
    AllUserRequests,
    IsLoading,
    navigate,
    DeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
  };
};

export default UserRequestsViewModel;
